//      
import getWindowFromEl from '../window/get-window-from-el';

export default function isHtmlElement(el        )                  {
  return el instanceof getWindowFromEl(el).HTMLElement;
}



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/is-type-of-element/is-html-element.js